/**
 * Application configuration
 */

// API base URL - defaults to local development
export const API_BASE_URL = import.meta.env.VITE_BRAIN_API_URL || 'http://localhost:8000';

// WebSocket base URL - dynamically set based on protocol
export const getWebSocketBaseURL = () => {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const host = import.meta.env.VITE_WS_HOST || window.location.host;
  return `${protocol}//${host}/ws`;
};

// Authentication settings
export const AUTH_CONFIG = {
  tokenStorageKey: 'astrapeak_auth_token',
  refreshTokenStorageKey: 'astrapeak_refresh_token',
  tokenExpiryKey: 'astrapeak_token_expiry',
  refreshThresholdMinutes: 5
};

// Feature flags
export const FEATURES = {
  enableConnectorHealthMonitoring: true,
  enableConnectorCredentialRotation: true,
  enableConnectorTypeFiltering: true
};

// Default pagination settings
export const PAGINATION = {
  defaultPageSize: 10,
  pageSizeOptions: [5, 10, 20, 50, 100]
};

// Date format settings
export const DATE_FORMAT = {
  display: 'MMM D, YYYY h:mm A',
  iso: 'YYYY-MM-DDTHH:mm:ss.SSSZ'
};

// Theme settings
export const THEME = {
  primaryColor: '#1976d2',
  secondaryColor: '#dc004e',
  errorColor: '#f44336',
  warningColor: '#ff9800',
  infoColor: '#2196f3',
  successColor: '#4caf50'
};
